import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { TextField } from '@mui/material';

import { regExps } from '../../utils/formValidation/validationPatterns';

import classes from './searchStyles/dynamicSearch.module.css';

const DynamicSearch = ({
    id = '',
    search,
    searchTerm,
    placeholder,
    disabled = false,
    autocomplete = 'on'
}) => {
    const onSearch = (value) => search(value.replace(regExps.SEARCH_R, ''));

    return (
        <div className={classes.dynamicSearch} data-testid={`${id}_search`}>
            <TextField
                type="search"
                placeholder={placeholder}
                size={'small'}
                value={searchTerm}
                disabled={disabled}
                autoComplete={autocomplete}
                onChange={(e) => onSearch(e.target.value)}></TextField>
            <div className={`${classes.icons} ${disabled ? classes.disabled : ''}`}>
                {!searchTerm ? (
                    <SearchIcon />
                ) : (
                    <ClearIcon onClick={() => search('')} className={classes.clear} />
                )}
            </div>
        </div>
    );
};

DynamicSearch.propTypes = {
    id: PropTypes.string,
    search: PropTypes.func.isRequired,
    searchTerm: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    autocomplete: PropTypes.string
};

export default DynamicSearch;
